import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {Box, Button, ClickAwayListener, InputAdornment, Link, Popper, styled, TextField, Typography, useMediaQuery} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SearchTrending from './SearchTrending';


interface SearchOption {
    id: number,
    title: string,
    link: string,
    category: string
}

interface SearchInputProps {
    searchInput?: string;
    updateSearchInput?: (searchInput: string) => void;
}

const defaultSearchOptions = [
    {
        id: Math.random(),
        title: 'Candidates Listing',
        link: '/Filers/',
        category: 'Popular Services'
    },
    {
        id: Math.random(),
        title: 'Contributions Database',
        link: '/Data/searchItems',
        category: 'Popular Services'
    },
    {
        id: Math.random(),
        title: 'Contribution Limit Chart',
        link: '/Legal/ContributionLimits',
        category: 'Popular Services'
    },
    {
        id: Math.random(),
        title: 'OCPF Forms',
        link: '/Publications/Forms',
        category: 'Popular Services'
    },
    {
        id: Math.random(),
        title: 'Treasurer Change',
        link: '/Search',
        category: 'Trending (Monthly Top Searches)'
    },
    {
        id: Math.random(),
        title: 'Year End',
        link: '/Search',
        category: 'Trending (Monthly Top Searches)'
    },
    {
        id: Math.random(),
        title: 'Michelle Wu, Mayoral Boston',
        link: '/Filers?q=15563',
        category: 'Trending (Monthly Top Searches)'
    },
    {
        id: Math.random(),
        title: 'EIN',
        link: '/Search',
        category: 'Trending (Monthly Top Searches)'
    },
]

const SearchInput = (props:SearchInputProps): JSX.Element => {
  
    useEffect(() => {   
        setSearchInput(props.searchInput || '');
    }, [props.searchInput]);

    const location = useLocation();
    const theme = useTheme();
    const [searchInput, setSearchInput] = useState<string>(props.searchInput || '');
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [openTreanding, setTrendingOpen] = useState(false);
    
    const displaySearchTrending = window.location.pathname.toLocaleLowerCase().includes('search') ? false : true;
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    // to be decided later: auto complete search options
    const [searchOptions, setSearchOptions] = useState<readonly SearchOption[]>(defaultSearchOptions);
    const [selectedOption, setSelectedOption] = useState<SearchOption>();
    const updateSelectedOption = (option: SearchOption) => {
        setSelectedOption(option);
        window.location.href = option.link;
      }
    
      const clearSelectedOption = () => {
        setSelectedOption(undefined);
      }

    const GroupHeader = styled(Typography)(() => ({
        fontSize: 14,
        fontWeight: 550,
        fontStyle: 'italic',
        padding: '4px 4px',
      }));
      
      const GroupItems = styled(Link)({
        fontSize: 13,
        textDecoration: 'none',
        padding: 0,
      });
    
     const changeSearchInput = (event: any) => {
         showSearchTrending(event);
         setSearchInput(event.target.value);
         setTrendingOpen(false);
    };

    

    const showSearchTrending = (event: any) => {
        if(!displaySearchTrending) return;
        if(!isMd) return;
        setAnchorEl(event.currentTarget);
        setTrendingOpen(true);
    }

    const hideSearchTrending = () => {
        setTrendingOpen(false);
        setAnchorEl(null);
    }

     const updateSearchInput = () => {
        if (props.updateSearchInput) {
            props.updateSearchInput(searchInput);
        }
        let pathname = location.pathname; 
        if(pathname !== '/Search'){
            window.location.href = '/Search?q=' + searchInput;
        }
     }

     const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            updateSearchInput();
        }
      };

    return (
    <>
        <Box display="flex" alignItems={'center'} onMouseLeave={hideSearchTrending} sx={{ width: '100%' }} >
            <Box width={1} marginRight={1}>
            <TextField
                sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                    border: '0 !important',
                },
                
                }}
                variant="outlined"
                color="primary"
                size="medium"
                placeholder="Search ocpf.us or ask a question"
                defaultValue={props.searchInput}
                value={searchInput}
                onChange={changeSearchInput}
                onMouseEnter={showSearchTrending}
                fullWidth
                onKeyDown={handleKeyDown}
                slotProps={{
                    input:{
                        startAdornment: 
                        <InputAdornment position="start">
                            <SearchIcon 
                                color="primary" 
                                fontSize='large'
                            >
                            </SearchIcon>
                        </InputAdornment>
                    },
                }}
            />
            </Box>
            <Box>
                <Button
                    sx={{ height: 34, minWidth: 75, whiteSpace: 'nowrap' }}
                    variant="contained"
                    color="primary"
                    size="medium"
                    fullWidth
                    onClick={updateSearchInput}
                >
                Search
                </Button>
            </Box>
            <ClickAwayListener onClickAway={hideSearchTrending}>
                <Popper
                    open={openTreanding}
                    anchorEl={anchorEl}
                    placement={"bottom-start"}
                    sx={{width: '500px'}}
                >
                    <Box sx={{ p:1, width: '100%'}}>
                        <SearchTrending></SearchTrending>
                    </Box>
                </Popper>
            </ClickAwayListener>
        </Box>

        {/*
            
    <Autocomplete
            //filterOptions={(x) => x}    
            //freeSolo
            sx={{ width: '95%' }}
            onChange={(event: any, newValue: SearchOption | null) => {
                if (newValue) {
                    updateSelectedOption(newValue);
                }
                else{
                    clearSelectedOption();
                }
              }}
            options={searchOptions}
            //isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.title}          
            groupBy={(option) => option.category}
            renderInput={(params) => 
                <TextField {...params} 
                    sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: '0 !important',
                    },
                    '& .MuiOutlinedInput-root': {
                        paddingRight: '0 !important',
                    }
                }}
                variant="outlined"
                color="primary"
                size="medium"
                placeholder="What are you looking for?"
                value={searchInput}
                onChange={changeSearchInput}
                fullWidth
                slotProps={{
                    input: {
                        ...params.InputProps,
                        startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="primary" fontSize='large'/>
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                             <Button
                                sx={{ height: 34, minWidth: 75, whiteSpace: 'nowrap' }}
                                variant="contained"
                                color="primary"
                                size="medium" 
                                component={Link}
                                onClick={updateSearchInput}
                            >
                                Search
                            </Button>
                        </InputAdornment>
                        )
                    },
                }}
                />
            }
            renderGroup={(params) => (
                <List dense key={params.key}>
                    <GroupHeader>{params.group}</GroupHeader>
                    <GroupItems>{params.children}</GroupItems>
                </List>
            )}
        />         

        */}
</>
    );
};

export default SearchInput;
